module.exports = __webpack_public_path__ + "img/history_icon.1aee962d.svg";